module.exports = __webpack_public_path__ + "img/TrotzDesGlückesEinRiss.4707bc34.png";